/// <amd-module name="Feed/Legacy/Protocols/UPack/UPackOverviewAttributesPanel" />
import * as React from "react";

import { IPackageDetailsProps } from "Feed/Legacy/Protocols/Common/IPackageDetailsProps";
import { IProjectAttribute, PackageDevelopment } from "Feed/Legacy/Protocols/Components/PackageDevelopment";
import { PackageProvenance } from "Feed/Legacy/Protocols/Components/PackageProvenance";
import { PackageStats } from "Feed/Legacy/Protocols/Components/PackageStats";
import { PackageTags } from "Feed/Legacy/Protocols/Components/PackageTags";

export class UPackOverviewAttributesPanel extends React.PureComponent<IPackageDetailsProps> {
    public render(): JSX.Element {
        const projectAttributes: IProjectAttribute[] = [];

        return (
            <div className="upack-overview-attributes-panel">
                <PackageProvenance
                    pageContext={this.props.pageContext}
                    feed={this.props.feed}
                    packageId={this.props.packageSummary.id}
                    versionId={this.props.packageVersion.id}
                    publishDate={new Date(this.props.packageVersion.publishDate)}
                    isProvenanceEnabled={this.props.isProvenanceEnabled}
                    isProvenanceSupported={true}
                />
                <PackageDevelopment
                    pageContext={this.props.pageContext}
                    projectAttributes={projectAttributes}
                    packageSummary={this.props.packageSummary}
                    packageVersion={this.props.packageVersion}
                />
                {this.props.isMetricsEnabled && (
                    <PackageStats
                        packageVersionMetrics={this.props.packageVersionMetrics}
                        packageMetrics={this.props.packageMetrics}
                        isMetricsLoading={this.props.isMetricsLoading}
                        feed={this.props.feed}
                    />
                )}
                <PackageTags tags={this.props.packageVersion.tags} />
            </div>
        );
    }
}
